import React, { useEffect, useState } from "react";
import { Modal, ConfigProvider, Divider, Image } from "antd";
import { getOfferText, getOptionSelectedValueOf } from "../../utils/Common";
import MealAdditionItems from "../restaurants/foods/MealAdditionItems";
import useScrollLock from "../../hooks/useScrollLock";
import FoodTaxAndDiscountView from "../restaurants/foods/FoodTaxAndDiscountView";

function ViewFoodModal({ openModal, records }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [filteredVariants, setFilteredVariants] = useState([]);
  const [additionGroups, setAdditionGroups] = useState([]);

  // Lock scroll when modal is open
  useScrollLock(openModal);

  const handleOk = () => {
    records.onCancel();
    setSelectedIndex(0);
  };
  const handleCancel = () => {
    records.onCancel();
    setSelectedIndex(0);
  };
  const onSelectOption = (index) => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    if (records.param.variants) {
      setFilteredVariants(records.param.variants.filter(text => !text.includes('System Default')));
    }
    if (records.param.additionGroups) {
      setAdditionGroups(records.param.additionGroups)
    }
  }, [records]);

  const mealAdditionSections = [
    {
      name: "Choose Your Sides",
      price: "Free",
      items: ["Mashed Potatoes", "Fries", "Grilled Veggies", "Extra Cheese"],
    },
    {
      name: "Choose Sauce",
      price: "20.00 TK",
      items: ["Grilled Prawns", "Peppercorn", "Garlic Butter"],
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        maskClosable={false}
        open={openModal}
        width={900}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular">
          <div className="text-2xl font-ubold">
            {records.param.includes?.length > 0 ? "Set Menu Details" : "Food Details"}
          </div>
          <Divider />
          <div className="flex flex-col">
            {records?.param &&
              records?.param?.options &&
              records?.param?.options.length > 0 ? (
              <div className="flex flex-row">
                <Image
                  width={120}
                  height={120}
                  src={records.param.image}
                  fallback={"/images/tabletap.svg"}
                />
                <div className="flex flex-col ml-[12px]">
                  <div className="text-xl font-ubold break-all max-w-full">
                    {records?.param?.name}
                  </div>
                  <div className="text-lg font-ubold text-pink">{`Price - ${getOptionSelectedValueOf("price", records, selectedIndex)} TK`}</div>
                  <div className="flex flex-col">
                    {records.param.discount !== 0 && (
                      <div className="text-md font-ubold text-green">
                        {`Discount
                        - ${getOptionSelectedValueOf("discount", records, selectedIndex)}
                        ${records.param.options['0'].isDiscountInPercent ? "%" : "TK"}`}
                      </div>
                    )}

                    {getOfferText(
                      getOptionSelectedValueOf("price", records, selectedIndex),
                      getOptionSelectedValueOf("discount", records, selectedIndex),
                      records.param.options['0'].isDiscountInPercent
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {/*<Divider />*/}
            <FoodTaxAndDiscountView
              data={{
                isVatApplicable: records.param.isVatApplicable,
                isDiscountApplicable: records.param.isDiscountApplicable,
                isSupplementaryDutyApplicable:
                  records.param.isSupplementaryDutyApplicable,
                supplementaryDuty: Number(records.param.supplementaryDuty || 0),
              }}
            />
            {/*<Divider />*/}
            <div className="text-md">{records.param.description}</div>
            {filteredVariants.length > 0 ||
              records.param.addons?.length > 0 ? (
              <Divider />
            ) : (
              ""
            )}

            {filteredVariants.length > 0 && records.param?.includes.length === 0 ? (
              <div className="mb-[24px]">
                <div className="font-ubold text-md">Variants</div>
                <div className="font-ubold text-md flex flex-row flex-wrap items-center space-y-[5px]">
                  {filteredVariants.filter(item => !item.includes('System Default')).map((item, index) => {
                    let activeStyle = {
                      background:
                        index === selectedIndex ? "#572D86" : "#FAFAFA",
                      color: index === selectedIndex ? "#FFFFFF" : "#000000",
                      borderColor:
                        index === selectedIndex ? "#572D86" : "#000000",
                    };
                    return (
                      <div
                        onClick={() => onSelectOption(index)}
                        style={activeStyle}
                        className="cursor-pointer font-uregular border-[1px] bg-purple text-white mr-[8px] px-[12px] rounded-[12px] break-words break-all whitespace-normal"
                        key={`variant${index}`}
                      >
                        {item}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            )}

            {records.param.includes?.length > 0 ? (
              <>
                {records.param.includes.map((item, index) => {
                  return (
                    <div
                      className="w-[100%] flex justify-between items-center space-y-3"
                      key={index}
                    >
                      <div className="w-[calc(60%-50px)] break-all font-uregular text-md">
                        {item.foodName}
                      </div>
                      <div className="w-[25%] font-uregular text-md">
                        <p>{item.optionName === 'System Default' ? '' : item.optionName}</p>
                      </div>
                      <div className="w-[15%] text-center font-uregular text-md">
                        QTY - {item.quantity}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              ""
            )}

            {records.param.includes?.length > 0 ||
              records.param.includes?.length > 0 && (
                <Divider />
              )}

            {/* addons section */}
            <div className="mt-5">
              {records.param.addons?.length > 0 ? (
                <>
                  <div className="font-ubold text-md py-2">Add-Ons</div>
                  <div className="font-ubold text-md flex flex-row flex-wrap items-center space-y-[5px]">
                    {records.param.addons?.map((item, index) => {
                      return (
                        <div
                          className="font-uregular bg-purple text-white  mr-[8px] px-[12px] rounded-[12px] break-words break-all whitespace-normal"
                          key={`variant${index}`}
                        >
                          {item}
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                ""
              )}
            </div>

            {/* Meal Addition */}
            <div className="w-full mx-auto mt-10">
              <MealAdditionItems additionGroups={additionGroups} />
            </div>
          </div>
          <Divider />
        </div>
      </Modal>
    </ConfigProvider>
  );
}

export default ViewFoodModal;
